import { useInfiniteQuery } from 'react-query';

import { api } from '../../../services/apiClient';
import { assertIsDataResponse } from '../assertIsDataResponse';
import { Blog } from './types';

type IReactQueryResponse = {
  results: Blog[];
  next: number | undefined;
};

type IQuery = {
  pageParam: number;
};

async function getData({ pageParam = 1 }: IQuery) {
  const response = await api.get(`blog/?page=${pageParam}`);

  const data: IReactQueryResponse = {
    results: response.data.results,
    next:
      response.data.last_page === 0 ||
      response.data.results.length === 0 ||
      response.data.last_page === pageParam
        ? undefined
        : pageParam + 1,
  };
  return data;
}

function useBlog() {
  return useInfiniteQuery<IReactQueryResponse, Error>(
    ['Blog'],
    (queryKey) => getData({ pageParam: queryKey.pageParam }),
    {
      getNextPageParam: (nextPage) => nextPage.next,
    }
  );
}

export { useBlog };
